import * as z from "zod";
import { requiredString } from "components/form/utils";
import { Bookmark } from "lucide-react";

export const bookmarkSchema = z.object({
    label: requiredString("Name is required"),
    url: requiredString("Please enter a valid URL"),
    description: z.string().optional(),
});

export default bookmarkSchema;